import { createAction, props } from '@ngrx/store';
import { ErrorResponse, IGenericError } from '../../../../src/app/core/models/generic-models';
import { IStaticDataCountriesResponse } from '../models/static-data-countries.model';

export const loadStaticDataCountries = createAction(
  '[StaticDataCountries] Load StaticDataCountries',
  props<{ noLoader: boolean}>(),
  );

export const loadStaticDataCountriesSuccess = createAction(
  '[StaticDataCountries] Load StaticDataCountries Success',
  props<{ response: IStaticDataCountriesResponse[] }>()
);

export const loadStaticDataCountriesFailure = createAction(
  '[StaticDataCountries] Load StaticDataCountries Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);
